module.exports = __webpack_public_path__ + "img/woman_back.f025a33c.png";